export const chartConfig = {
  chart: {
    type: "column",
    animation: false
  },
  title: {
    align: "center",
    text: "",
    style: {
      fontWeight: "bold",
      color: "#121212",
      fontSize: "15px"
    }
  },
  subtitle: {
    align: "center",
    text: "",
    style: {
      fontWeight: "bold",
      color: "#121212"
    }
  }
};
